import {fileConfigs } from "./configs";

// Helper function for setting errors
const setFieldError = (setErrors, fieldName, message) => {
  setErrors((prev) => ({
    ...prev,
    [fieldName]: message,
  }));
};

const getSizeInKB = (bytes) => Number((bytes / 1024).toFixed(2));

const getSizeInMB = (kb) => Number((kb / 1024).toFixed(4));

const getCurrentPageName = () => {
 let currentPageName = window.location.pathname.split("/").pop();
 return currentPageName.charAt(0).toLowerCase() + currentPageName.slice(1)
};

export const validateFile = (file, setErrors, fieldName, fileType) => {
  try {
    const curPathName = getCurrentPageName();
    if (!file) {
      setFieldError(setErrors, fieldName, 'No file selected');
      return false;
    }
    
    // Detect file type
    const isPDF = file.type === "application/pdf";
    const isDOC = file.type === "application/msword" || file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    const isImage = file.type.startsWith("image/");

    // Retrieve validation rules
    const config = fileConfigs[fileType]?.[curPathName]?.[fieldName];
    if (!config) {
      console.error('This file type is not allowed here. Please upload a valid file.');
      setFieldError(setErrors, fieldName, 'This file type is not allowed here. Please upload a valid file.');
      return false;
    }

    const { size, dimension ,unit = 'KB'} = config;
    const fileSizeInKB = getSizeInKB(file.size);
    const fileSizeInMB = getSizeInMB(fileSizeInKB);
    const actualSize = unit === 'MB' ? fileSizeInMB : fileSizeInKB;

    // ✅ PDF Validation (Size Only)
    if (isPDF) {
      if (actualSize > size.max || actualSize < (size.min || 0)) {
        setFieldError(setErrors, fieldName, `PDF size must be between  ${size.min || 0} ${unit} to  ${size.max} ${unit}. Current Size: ${actualSize} ${unit}.`);
        return false;
      }
      setErrors({}); // Clear errors
      return true;
    }
    // ✅ Word Doc file Validation (Size Only)
    if (isDOC) {
      if (actualSize > size.max || actualSize < (size.min || 0)) {
        setFieldError(setErrors, fieldName, `Word Doc's size must be between  ${size.min || 0} ${unit} to ${size.max} ${unit}. Current Size: ${actualSize} ${unit}.`);
        return false;
      }
      setErrors({}); // Clear errors
      return true;
    }


    // ✅ Image Validation (Size + Dimensions)
    if (isImage) {
      if (actualSize> size.max || actualSize < (size.min || 0)) {
        setFieldError(setErrors, fieldName, `Image size must be between ${size.min || 0} ${unit} to ${size.max} ${unit}. Current Size: ${actualSize} ${unit}.`);
        return false;
    }

      return validateImageDimensions(file, fieldName, dimension, setErrors);
    }
  } catch (error) {
    console.log('error', error);
  }
};


export const validateImageDimensions = (file, fieldName, dimension, setErrors) => {
  try {
    const { height, width } = dimension;
    return new Promise((resolve) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width !== width || img.height !== height) {
          setFieldError(setErrors, fieldName, `Dimensions must be ${width}x${height} pixels.`);
          resolve(false);
        } else {
          setErrors(""); // Clear errors
          resolve(true);
        }
      };
    });
  } catch (error) {
    console.error("Validation error:", error);
  }
};
